$(document).ready(() => {
    RegisterFieldBinders($(document) as unknown as JQuery<HTMLElement>);
});

function RegisterFieldBinders($context: JQuery<HTMLElement>): void {

    $context.findInGrid('div[name="DetailsUser"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "User",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsRole"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "Role",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsPermission"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "Permission",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsWebsiteContent"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "WebsiteContent",
            getDetails: function (this: FieldsBinder, event: any) {
                const $editor = this.$parent.find('[name="WebsiteContentData"]');

                if ($editor.length) {
                    const summernoteEditor = ($editor as any).summernote();
                    const isHtmlMode = summernoteEditor.summernote('codeview.isActivated');

                    if (isHtmlMode) {
                        summernoteEditor.summernote('codeview.deactivate');
                    }
                }

                return this.getDefaultDetails(event);
            }
        });

        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsAllSqlQuery"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "AllSqlQuery",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsGender"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "Gender",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsStateCode"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "StateCode",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsCountyCode"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "CountyCode",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsCityCode"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "CityCode",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsZipCode"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "ZipCode",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsCollegeUniversity"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "CollegeUniversity",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsEthnicity"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "Ethnicity",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsExemptionType"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "ExemptionType",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsGenderIdentity"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "GenderIdentity",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsGrade"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "Grade",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsNationalOrigin"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "NationalOrigin",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsRace"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "Race",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsSchoolCategory"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "SchoolCategory",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsSchoolDistrictCategory"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "SchoolDistrictCategory",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsSchoolLevel"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "SchoolLevel",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsSchoolType"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "SchoolType",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsSchoolYear"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "SchoolYear",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsSchoolDistrict"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "SchoolDistrict",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsSchool"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "School",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsSchoolGrade"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "SchoolGrade",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsVaccineExemption"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "VaccineExemption",
            isFormData: true,
            bindAdditionalButtons: function (this: FieldsBinder) {
                createRaceCascadeBinder().call(this);

                this.$parent.findInGrid('button[name="btnCopyStudentInfoToParent"]').on('click', (event: any) => {
                    copyStudentInfoToParent().call(this);
                });
            },
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsVaccineExemptionPublic"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "VaccineExemption",
            addUrl: "AddPublic",
            isFormData: true,
            bindAdditionalButtons: function (this: FieldsBinder) {
                createRaceCascadeBinder().call(this);

                this.$parent.findInGrid('button[name="btnReviewPublic"]').on('click', (event: any) => {
                    const ajaxOptions: JQueryAjaxSettings = {
                        type: "POST",
                        url: `${window.appRoot}${this.controller}/ReviewPublic`,
                        data: this.getDetails(event),
                        success: (data: AjaxSaveDetailsResult) => {
                            if (data.Success) {
                                //Set the VaccineExemptionId if it was saved.
                                if (data.Id) {
                                    this.$parent.findInGrid('input[name="VaccineExemptionId"]').val(data.Id);
                                }

                                //Clear any left over messages from earlier attempts
                                clearMessageErrors(this.$parent);

                                //Load the ReveiwContent Section
                                if (data.Html) {
                                    var $reviewContent = $('#reviewContent');
                                    $reviewContent.html(data.Html);
                                    BindCommon($reviewContent);
                                }

                                //Hide the Add section and show the Review section
                                $('#addSection').hide();
                                $('#reviewSection').show();
                            }

                            if (data.SaveMessageView) {
                                appendMessagePartial(this.$parent, data.SaveMessageView);
                                $('html, body').animate({ scrollTop: 0 }, 100);
                            }
                        },
                        error: (_xhr, _status, error) => {
                            console.log(error);
                            if (_xhr.status == 403) {
                                setMessageError(this.$parent, "Access Denied");
                            } else {
                                setMessageError(this.$parent, error);
                            }
                        }
                    };

                    if (this.isFormData) {
                        ajaxOptions.contentType = false;
                        ajaxOptions.processData = false;
                    }

                    $.ajax(ajaxOptions);
                });

                this.$parent.findInGrid('button[name="btnEditPublic"]').on('click', (event: any) => {
                    $('#addSection').show();
                    $('#reviewSection').hide();
                });

                this.$parent.findInGrid('button[name="btnSubmitPublic"]').on('click', (event: any) => {
                    const details = this.getDetails(event);

                    window.open(
                        `${window.appRoot}${this.controller}/PrintNotaryForm?id=${details.get("VaccineExemptionId")}`,
                        "_blank",
                        "noopener,noreferrer"
                    );

                    const ajaxOptions: JQueryAjaxSettings = {
                        type: "POST",
                        url: `${window.appRoot}${this.controller}/SubmitPublic`,
                        data: details,
                        success: (data: AjaxSaveDetailsResult) => {
                            if (data.Success) {
                                window.location.href = data.RedirectUrl!;
                                return;
                            }

                            if (data.SaveMessageView) {
                                appendMessagePartial(this.$parent, data.SaveMessageView);
                                $('html, body').animate({ scrollTop: 0 }, 100);
                            }
                        },
                        error: (_xhr, _status, error) => {
                            console.log(error);
                            if (_xhr.status == 403) {
                                setMessageError(this.$parent, "Access Denied");
                            } else {
                                setMessageError(this.$parent, error);
                            }
                        }
                    };

                    if (this.isFormData) {
                        ajaxOptions.contentType = false;
                        ajaxOptions.processData = false;
                    }

                    $.ajax(ajaxOptions);
                });

                this.$parent.findInGrid('button[name="btnCopyStudentInfoToParent"]').on('click', (event: any) => {
                    copyStudentInfoToParent().call(this);
                });
            },
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsVaccineExemptionSummary"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "VaccineExemptionSummary",
        });
        fieldsBinder.bindSaveButtons();
    });

    $context.findInGrid('div[name="DetailsReportContent"]').each(function () {
        const fieldsBinder = new FieldsBinder({
            $parent: $(this),
            controller: "ReportContent",
            isFormData: true,
        });
        fieldsBinder.bindSaveButtons();
    });
}

function createRaceCascadeBinder(): (this: FieldsBinder) => void {
    return function (this: FieldsBinder): void {
        const $race1 = this.$parent.findInGrid('select[name="Race1Id"]') as JQuery<HTMLSelectElement>;
        const $race2 = this.$parent.findInGrid('select[name="Race2Id"]') as JQuery<HTMLSelectElement>;
        const $race3 = this.$parent.findInGrid('select[name="Race3Id"]') as JQuery<HTMLSelectElement>;

        const race2OriginalHtml = $race2.html() || "";
        const race3OriginalHtml = $race3.html() || "";

        function rebuild(
            $dropdown: JQuery<HTMLSelectElement>,
            originalHtml: string,
            excluded: string[],
            lockToBlank: boolean = false
        ): void {
            const current = $dropdown.val() as string | null;

            $dropdown.empty();

            const $options = $(originalHtml);

            // -------------------------
            // LOCKED MODE: ONLY BLANK
            // -------------------------
            if (lockToBlank) {
                const $blank = $options.filter(function () {
                    return ($(this).attr("value") || "") === "";
                });

                $dropdown.append($blank.clone());
                $dropdown.val("");

                return;
            }

            // -------------------------
            // NORMAL MODE
            // -------------------------
            $options.each(function () {
                const $opt = $(this);
                const value = $opt.attr("value") || "";

                // always keep blank option
                if (!value) {
                    $dropdown.append($opt.clone());
                    return;
                }

                // apply exclusions
                if (excluded.includes(value)) {
                    return;
                }

                $dropdown.append($opt.clone());
            });

            // restore selection if still valid
            if (current && $dropdown.find(`option[value="${current}"]`).length > 0) {
                $dropdown.val(current);
            } else {
                $dropdown.val("");
            }
        }

        function refresh(): void {
            const race1 = $race1.val() as string | null;
            const race2 = $race2.val() as string | null;

            // -------------------------
            // LEVEL 1: Race1 not selected
            // -------------------------
            if (!race1) {
                rebuild($race2, race2OriginalHtml, [], true);
                rebuild($race3, race3OriginalHtml, [], true);

                return;
            }

            // -------------------------
            // LEVEL 2: Race1 selected → build Race2
            // -------------------------
            rebuild($race2, race2OriginalHtml, [race1], false);

            const updatedRace2 = $race2.val() as string | null;

            // -------------------------
            // LEVEL 3: Race2 not selected → lock Race3
            // -------------------------
            if (!updatedRace2) {
                rebuild($race3, race3OriginalHtml, [], true);
                return;
            }

            // -------------------------
            // LEVEL 3: Race2 selected → build Race3
            // -------------------------
            rebuild($race3, race3OriginalHtml, [race1, updatedRace2], false);
        }

        // Bind events
        $race1.on("change", refresh);
        $race2.on("change", refresh);

        refresh();
    };
}

function copyStudentInfoToParent(): (this: FieldsBinder) => void {
    return function (this: FieldsBinder): void {
        var studentAddress1 = this.$parent.findInGrid('input[name="StudentAddress1"]').val();
        if (studentAddress1 !== undefined) {
            this.$parent.findInGrid('input[name="ParentAddress1"]').val(studentAddress1);
        }

        var studentAddress2 = this.$parent.findInGrid('input[name="StudentAddress2"]').val();
        if (studentAddress2 !== undefined) {
            this.$parent.findInGrid('input[name="ParentAddress2"]').val(studentAddress2);
        }

        var studentEmail = this.$parent.findInGrid('input[name="StudentEmailAddress"]').val();
        if (studentEmail !== undefined) {
            this.$parent.findInGrid('input[name="ParentEmailAddress"]').val(studentEmail);
        }

        var studentState = this.$parent.findInGrid('select[name="StudentStateCodeId"]').val();
        if (studentState !== undefined) {
            this.$parent.findInGrid('select[name="ParentStateCodeId"]').val(studentState).trigger("change");
        }

        var studentCounty = this.$parent.findInGrid('select[name="StudentCountyCodeId"]').val();
        if (studentCounty !== undefined) {
            this.$parent.findInGrid('select[name="ParentCountyCodeId"]').val(studentCounty).trigger("change");
        }

        var studentCity = this.$parent.findInGrid('select[name="StudentCityCodeId"]').val();
        if (studentCity !== undefined) {
            this.$parent.findInGrid('select[name="ParentCityCodeId"]').val(studentCity).trigger("change");
        }

        var studentZip = this.$parent.findInGrid('select[name="StudentZipCodeId"]').val();
        if (studentZip !== undefined) {
            this.$parent.findInGrid('select[name="ParentZipCodeId"]').val(studentZip).trigger("change");
        }

        var studentPhone = this.$parent.findInGrid('input[name="StudentPhoneNumber"]').val();
        if (studentPhone !== undefined) {
            this.$parent.findInGrid('input[name="ParentPhoneNumber"]').val(studentPhone);
        }

        var studentEmail = this.$parent.findInGrid('input[name="StudentEmailAddress"]').val();
        if (studentEmail !== undefined) {
            this.$parent.findInGrid('input[name="ParentEmailAddress"]').val(studentEmail);
        }
    }
}